(() => {
  const PRODUCT_ID = '8197282136256';
  const VARIANT_IDS = {
    'Small|Long leg': '46169625362624',
    'Small|Short regular leg': '46169625395392',
    'Medium|Long leg': '46169625428160',
    'Medium|Short regular leg': '46169625460928',
    'Large|Long leg': '46169625493696',
    'Large|Short regular leg': '46169625526464',
    'XL|Long leg': '46169625559232',
    'XL|Short regular leg': '46169625592000',
  };

  const filterGalleryByFit = () => {
    const productInfo = document.querySelector(`product-info[data-product-id="${PRODUCT_ID}"]`);
    if (!productInfo) return;

    const selectedLeg = productInfo.querySelector(
      'input[type="radio"][data-option-name="Leg Type"]:checked'
    )?.value;
    if (!selectedLeg) return;

    const oppositeFit = selectedLeg === 'Long leg' ? 'short-leg' : 'long-leg';
    const gallery = productInfo.querySelector('media-gallery');
    if (!gallery) return;

    gallery.querySelectorAll('li[data-media-id]').forEach((mediaItem) => {
      const alt = mediaItem.querySelector('img')?.alt?.toLowerCase() || '';
      const isSharedComparison = alt.includes('short-leg') && alt.includes('long-leg');
      mediaItem.hidden = !isSharedComparison && alt.includes(oppositeFit);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', filterGalleryByFit, { once: true });
  } else {
    filterGalleryByFit();
  }

  document.addEventListener(
    'change',
    (event) => {
      const legInput = event.target;

      if (
        !(legInput instanceof HTMLInputElement) ||
        legInput.type !== 'radio' ||
        legInput.dataset.optionName !== 'Leg Type' ||
        !legInput.checked
      ) {
        return;
      }

      const productInfo = legInput.closest('product-info');
      if (!productInfo || productInfo.dataset.productId !== PRODUCT_ID) return;

      const sizeInput = productInfo.querySelector(
        'input[type="radio"][data-option-name="Size"]:checked'
      );
      const variantId = VARIANT_IDS[`${sizeInput?.value}|${legInput.value}`];
      if (!variantId) return;

      const nextUrl = `${productInfo.dataset.url}?variant=${variantId}`;
      if (`${window.location.pathname}${window.location.search}` === nextUrl) return;

      window.location.assign(nextUrl);
    },
    true
  );
})();
